import { SpaceApiError, readBaseInfo } from '@space/user-core'
import type { ProfileBaseInfo } from '@/modules/profile/types/profile'
import { ProfileApi } from '@/modules/profile/api/profileApi'
import { i18n } from '@/i18n'

export const loadProfileBaseInfo = async (isCurrent?: () => boolean): Promise<ProfileBaseInfo> => {
  const response = await ProfileApi.getBaseInfo(isCurrent)

  try {
    return readBaseInfo(response, { protocol: window.location.protocol })
  } catch (cause) {
    if (!(cause instanceof SpaceApiError)) throw cause
    const err = new Error(i18n.global.t('errors.profileLoadFailed')) as Error & { errorCode?: number }
    err.errorCode = cause.errorCode
    throw err
  }
}
